module.exports = __webpack_public_path__ + "static/media/drone.8ab438d3.svg";


//////////////////
// WEBPACK FOOTER
// ./src/scenes/Wizard/parts/images/new/drone.svg
// module id = 532
// module chunks = 0